import React, { Children, cloneElement, useMemo, useState } from 'react';

interface PassoAPassoProps {
    ativo?: number;
    children: React.ReactElement | React.ReactElement[];
}

interface PassoProps {
    ativo?: number;
    children: React.ReactElement | React.ReactElement[] | string;
    chave?: number;
}

export const usePassoAPasso = () =>
{
    return useState<number>(1);
}

const PassoAPasso = ({ children, ativo = 1 }: PassoAPassoProps): React.ReactElement =>
{
    const blocos = useMemo(() => {
        const blocos = [];
        const quantidade = Children.count(children);

        for (let i = 1; i <= quantidade; i++) {
            blocos.push(i);
        }

        return blocos;
    }, [ children ]);

    return (
        <React.Fragment>
            <div className="position-relative w-50 mx-auto mb-5">
                <div className="progress" style={{ height: '5px' }}>
                    <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${(100 / (blocos.length - 1)) * (ativo - 1)}%` }}
                    />
                </div>
                <div className="w-100 d-flex justify-content-between position-absolute translate-middle start-50 top-50">
                    { blocos.map(bloco => (
                        <button
                            key={ bloco.toString() }
                            type="button"
                            className={ `btn btn-sm ${bloco <= ativo ? 'btn-primary' : 'btn-light'} rounded-pill` }
                            style={{ width: '2rem', height: '2rem' }}
                        >
                            { bloco }
                        </button>
                    )) }
                </div>
            </div>
            { Children.map(children, (children, chave) =>
                cloneElement(children, { chave: chave + 1, ativo })
            ) }
        </React.Fragment>
    )
}

export const Passo = ({ children, chave = 1, ativo }: PassoProps): React.ReactElement =>
{
    return (
        <React.Fragment>
            { chave == ativo && (
                <div className="animate__animated animate__fadeIn">
                    { children }
                </div>
            ) }
        </React.Fragment>
    )
}

export default PassoAPasso;
